/* eslint-disable no-secrets/no-secrets */
import React, {
    useCallback, useEffect, useState, useContext, useMemo,useRef
} from 'react';
import _ from 'lodash';
import { ViewModelServiceContext, ViewModelForm, useDataRefresh } from '@xengage/gw-portals-viewmodel-react';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';

import { useDependencies } from '@xengage/gw-portals-dependency-react';
// eslint-disable-next-line import/no-extraneous-dependencies
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { QuestionSetComponent, platformMessages } from 'ml-components-platform-react';
import { FormattedMessage, useTranslator } from '@jutro/locale';
import { MLModifierComponent } from 'ml-components-common-react';
import { MLDriverVehicleUtil, MLNotificationBlockUtil } from 'ml-portals-util-react';
import { MLModalService } from 'ml-portals-services-react';
import { MLNavigationStepsTrackingService } from 'ml-services-common-react';
import { MLEndorsementFlowUtil, MLEndorsementUtil, MLDisclosureUtil,MLProductCodeUtil } from 'ml-portals-util-js';
import { DriversListComponent, VehiclesListComponent } from 'ml-capability-quoteandbind-common-react';
import appConfig from 'app-config';
import PolChangeTrackEvent from 'gw-capability-gateway-quoteandbind-common-react/components/TrackEvent/PolChangeTrackEvent.jsx';
import metadata from './AdditionalPolicyInfoPolChange.metadata.json5';
import { PolicyChange} from 'gw-capability-policychange-common-react';
import { Identify  } from '../../../gw-capability-gateway-quoteandbind-common-react/components/TrackEvent/TrackEvent';

import messages from './AdditionalPolicyInfoPolChange.messages';
import styles from './AdditionalPolicyInfoPolChange.module.scss';
import { ScrollToError } from '@jutro/legacy/wizard-next';


const PA_MODEL_PATH = 'lobData.personalAuto.coverables.value';
const HOP_MODEL_PATH = 'lobData.homeowners.coverables.value';
const PUP_MODEL_PATH = 'lobData.personalUmbrella.coverables.value';
const PA_MODIFIER_PATH = 'lobData.personalAuto.modifiers_ML';
const PRIMARY_VEHICLE_REQ_STATE_PATH = 'baseData.isDriverPrimaryVehicleRequiredState_Ext.value';
const STATE_PATH = 'baseData.policyAddress.state.value.code';
const HALF_DRIVER = 50;
const accidentPreventionCode = ['PADriversRoleModiferPreventionCourse_ML', 'PADriverAccidentPrevention_ML'];
const residentStudentCode = 'PADriverResidentStudent_ML';
const HO_MODIFIER_PATH = 'lobData.homeowners.modifiers_ML';
const PUP_MODIFIER_PATH = 'lobData.personalUmbrella.modifiers_ML';

const warningKey = 'warningKey';
const dwellingOccupancyKey = [
    'HOPPreQualHomeCondoDwellingOccupancy_Ext',
    'HOPPreQualLandlordDwellingOccupancy_Ext',
];

const dwellingOccupancyCode = {
    HomeCondoVacant: 'HOPPreQualHomeCondoOccupancyVacant',
    LandlordVacant: 'HOPPreQualLandlordOccupancyVacant',
};

const offeringLLHLLC = {
    LandlordCondo: 'HOPPlatinumLandLordCondo_Ext',
    LandlordHome: 'HOPDF3PlatinumLandLordHome_Ext',
};

const animalBittenOrAttackedKey = 'HOPPreQualAnimalBittenOrAttacked_Ext'
const isDayCareSelected = 'HOPPreQualDaycareOnPremise_ML'

const getFirstExisting = (obj, keys) =>
    keys.reduce((acc, key) => (acc ?? _.get(obj, key)), undefined);

const isTruthyYes = (val) => {
    const code =
        val == null
            ? undefined
            : (typeof val === 'object' ? val?.code : String(val));

    if (code === true || code === 'true') return true;

    const s = String(code || '').toUpperCase();
    return s === 'YES';
};


const AdditionalPolicyInfoPolChange = (props) => {
    const {
        wizardData, updateWizardData, goNext, currentStep, steps, currentStepIndex, changeNextSteps,
    } = props;

    const {
        onValidate, isComponentValid, registerComponentValidation
    } = useValidation('AdditionalPolicyInfoPolChange');

    const { refreshData } = useDataRefresh();

    const {
        showProgressDialog,
        showErrorModal
    } = MLModalService();

    const { submissionVM } = wizardData;
    const isGpa = appConfig.portalCode === 'GPA';

    const {
        isVehicleEligibleForAccidentPrevention,
        getRatedDriversNonStudent,
        validateVehiclesHaveAssignmentsForEveryDriver,
        validateVehicleAssignmentPercentages,
        displayNonAPModifierLAMessage
    } = MLDriverVehicleUtil();

    const {
        addErrorAlert,
        addWarningAlert,
        clearBlockAlerts
    } = MLNotificationBlockUtil();

    const translator = useTranslator();
    const [qualWarningsAck, setQualWarningsAck] = useState(false);
    const qualWarningsActiveRef = useRef(false);
    const offeringCode = _.get(submissionVM, 'lobData.homeowners.offerings.value[0].branchCode');
    const offeringName = _.get(submissionVM, 'lobData.homeowners.offerings.value[0].branchName');
    const isModernProduct = _.get(submissionVM, "isModernProduct_Ext.value", false);
    const isHomeOwnersPartialTypeHome = MLProductCodeUtil.isHomeOwnersPartialTypeHome(submissionVM?.lobData?.homeowners?.coverables?.coveragePartType_ML?.value?.code);
    const isHomeOwnersPartialTypeRental = MLProductCodeUtil.isHomeOwnersPartialTypeRental(submissionVM?.lobData?.homeowners?.coverables?.coveragePartType_ML?.value?.code);
    const isHomeOwnersPartialTypeCondo = MLProductCodeUtil.isHomeOwnersPartialTypeCondo(submissionVM?.lobData?.homeowners?.coverables?.coveragePartType_ML?.value?.code);
    const isLLHOrLLC = MLProductCodeUtil.isHomeOwnersPartialTypeLandlordHome(submissionVM?.lobData?.homeowners?.coverables?.coveragePartType_ML?.value?.code)
        || MLProductCodeUtil.isHomeOwnersPartialTypeLandlordCondo(submissionVM?.lobData?.homeowners?.coverables?.coveragePartType_ML?.value?.code);

    const { EndorsementService } = useDependencies('EndorsementService');
    const viewModelService = useContext(ViewModelServiceContext);
    const { authHeader } = useAuthentication();
    const DRIVERTYPE_TYPELIST = viewModelService.productMetadata.get('pc').types.getTypelist('DriverType_ML');
    const VEH_DRV_ERR = _.get(submissionVM, STATE_PATH) === 'LA' ? translator(messages.vehiclePercentageDriverError) : translator(messages.vehiclePrimaryDriverError);
    const TOTAL_PCT_ERROR = translator(messages.totalPercentageError);
    const ASSIGNMENT_REQ_ERR = translator(messages.assignmentRequiredError);
    const isPersonalAuto = submissionVM.value.isPersonalAuto();
    const isHomeowners = submissionVM.value.isHomeOwners();
    const isPersonalUmbrella = submissionVM.value.isPersonalUmbrella();
    const isCondo = submissionVM.value.isCondo();
    const questionSetCode = isHomeowners ? 'HOPPreQual' : 'PUPPreQual_PUE';
    const preQualQuestionSetPath = `lobData.${isHomeowners ? 'homeowners' : 'personalUmbrella'}.preQualQuestionSets.value[0]`;

    const isTilePage = useMemo(() => {
        if (isPersonalAuto) {
            return currentStep.mlStepName === 'endorsementPaAddlInfoAndQualification';
        }
        if (isHomeowners) {
            return currentStep.mlStepName === 'endorsementHoAddlInfoAndQualifications'
        }
        if (isPersonalUmbrella) {
            return currentStep.mlStepName === 'endorsementPupAddlInfoAndQualifications'
        }
        return false;
    }, [currentStep, isHomeowners, isPersonalAuto, isPersonalUmbrella])

    const HOAdditionalPolicyInfoContainer = isHomeowners;
    const PAAdditionalPolicyInfoContainer = isPersonalAuto;
    const PUPAdditionalPolicyInfoContainer = isPersonalUmbrella

    // Homeowners specific variables
    const dwellingInfoQuestionSetData = _.get(submissionVM,  'lobData.homeowners.dwellingAdditionalInfo.value[0]');
    const isVehiclePrimaryDriverState = _.get(submissionVM, 'baseData.isVehiclePrimaryDriverState_Ext.value');
    const isVehiclePrimaryDriverPercentageState = _.get(submissionVM, 'baseData.isVehiclePrimaryDriverPercentageState_Ext.value');
    const vehicleDriversVM = _.get(submissionVM, 'lobData.personalAuto.coverables.vehicleDrivers_Ext');
    const questionSets = _.get(submissionVM, 'lobData.personalAuto.questionSets_ML.value');
    const questionSetsAspects = _.get(submissionVM, 'lobData.personalAuto.questionSets_ML.aspects');
    const jobNumber = submissionVM.jobID.value;
    const paModifiers = _.get(submissionVM, PA_MODIFIER_PATH, undefined);
    const hoModifiers = _.get(submissionVM, HO_MODIFIER_PATH, undefined);
    const pupModifiers = _.get(submissionVM, PUP_MODIFIER_PATH, undefined);
    const isPrimaryVehicleReqState = _.get(submissionVM, PRIMARY_VEHICLE_REQ_STATE_PATH);
    const state = _.get(submissionVM, STATE_PATH);
    const WLBForSeniorsCode = 'PAWorkLossBenefitsForSeniors_Ext';

    const DWELLING_QUESTION_SET = {
        ANSWERS: {
            HAVE_ANIMALS: 'HOPHasAnimal_ML',
            DOG: 'HOPHasDog1_ML',
            FARM_ANIMALS: 'HOPHasFarmAnimals_ML',
            EXOTIC_ANIMALS: 'HOPHasExoticAnimal1_ML',
            OTHER: 'HOPHasOtherAnimals_ML'
        }
    };

    const PREQUAL_QUESTIONS_TO_REMOVE = [
        'HOPDwellingHomeSharingAirbnb_Ext'
    ];

    const updateWizardSubmissionData = useCallback((vm) => {
        _.set(wizardData, 'submissionVM', vm);
        updateWizardData(wizardData);
    }, [updateWizardData, wizardData]);

    // eslint-disable-next-line no-nested-ternary
    const modelPath = isPersonalAuto ? PA_MODEL_PATH : (isHomeowners ? HOP_MODEL_PATH : PUP_MODEL_PATH);
    const lineModel = _.get(submissionVM, modelPath);
    const { vehicles } = isPersonalAuto ? lineModel : '';
    const drivers = isPersonalAuto ? lineModel.drivers: '';
    const ratedDrivers = isPersonalAuto ? drivers.filter((driver) => driver.type_ML === DRIVERTYPE_TYPELIST.getCode('rated').code) : '';
    const hasPrimaryVehicleRequiredDriver = isPersonalAuto ? ratedDrivers.some((driver) => driver.showPrimaryVehicleQuestion) : undefined;
    const [nonAccidentPreventionDisplayed, setNonAccidentPreventionDisplayed] = useState(false);
    
    const [matureDriverDiscountWarning, setMatureDriverDiscountWarning] = useState(false);
    const [showErrors, setShowErrors] = useState(false);
    const [vehicleDriverErrors, setVehicleDriverErrors] = useState([]);
    const [hasError, setHasError] = useState(false);
    const [errorTimestamp, setErrorTimestamp] = useState(0);
    const [dogBreedsAndOtherExiotAnimals, setDogBreedsAndOtherExiotAnimals] = useState(
        {
            HOPDogBreed1_ML: null,
            HOPDogBreed2_ML: null,
            HOPDogBreed3_ML: null,
            HOPDogBreed4_ML: null,
            HOPDogBreed5_ML: null,
            HOPDogBreed6_ML: null,
            HOPDogBreed7_ML: null,
            HOPDogBreed8_ML: null,
            HOPDogBreed9_ML: null,
            HOPDogBreed10_ML: null,
            HOPExoticAnimalType1_ML: null,
            HOPExoticAnimalType2_ML: null,
            HOPExoticAnimalType3_ML: null,
            HOPExoticAnimalType4_ML: null,
            HOPExoticAnimalType5_ML: null,
            HOPExoticAnimalType6_ML: null,
            HOPExoticAnimalType7_ML: null,
            HOPExoticAnimalType8_ML: null,
            HOPExoticAnimalType9_ML: null,
            HOPExoticAnimalType10_ML: null
        });
    // eslint-disable-next-line no-nested-ternary
    const modifiers = isPersonalAuto ? paModifiers : (isHomeowners ? hoModifiers : pupModifiers);

    if (modifiers && modifiers.lineModifiers && modifiers.lineModifiers.value) {
        modifiers.lineModifiers.value.forEach(
            (mod) => {
                mod.savedFromPortal = true;
                mod.updated = true;
                mod.editMode_ML = true;
            }
        );
    }
    
    const resetValues = async () => {
        const ppcValues = await EndorsementService.callVeriskIntegration(
            submissionVM.jobID.value,
            authHeader)

        const newSubmissionVM = viewModelService.clone(submissionVM);

        _.set(
            newSubmissionVM,
            'lobData.homeowners.coverables.constructionDetails_ML.hydrantWithin1000Feet.value',
            ppcValues?.hydrantWithin1000Feet
        );

        _.set(
            newSubmissionVM,
            'lobData.homeowners.coverables.constructionDetails_ML.fireDistrictName.value',
            ppcValues?.fireDistrictName
        );

        const hydrantValue = ppcValues?.hydrantWithin1000Feet;
        const fireDistrict = ppcValues?.fireDistrictName ?? '';
        const fireDistrictValues = ppcValues?.fireDistrictNames

        setSelectedHydrantValue(hydrantValue);
        setSelectedFireDistrictValue(fireDistrict);
        setFireDistrictValues(fireDistrictValues);
        setIsFireDistrictEditable(!fireDistrict && fireDistrictValues.length > 1);
        setIsRefreshButtonVisible(isRefreshBtnVisible());
        setIsHydrantEditable(!isHydrantValueDisabled());


        _.set(newSubmissionVM, 'lobData.homeowners.coverables.constructionDetails_ML.hydrantWithin1000Feet.value', hydrantValue);
        _.set(newSubmissionVM, 'lobData.homeowners.coverables.constructionDetails_ML.fireDistrictName.value', fireDistrict);
        _.set(newSubmissionVM, 'lobData.homeowners.coverables.constructionDetails_ML.isFireDistrictNameEditable.value', !fireDistrict && fireDistrictValues.length > 1);

        
        updateWizardSubmissionData(newSubmissionVM);
        refreshData();
    };

    const homeownerCoverablesVM = _.get(submissionVM, 'lobData.homeowners.coverables');
    const constructionDetailsVM = _.get(homeownerCoverablesVM, 'constructionDetails_ML');
    const hydrant1000FtValue = _.get(constructionDetailsVM, 'hydrantWithin1000Feet.value');
    const fireDistrictInitialValues = _.get(constructionDetailsVM, 'fireDistrictNames.value', []);
    const fireDistrictName = _.get(constructionDetailsVM, 'fireDistrictName.value', '');
    const addressMatch = _.get(constructionDetailsVM, 'matchUsing.value.code', undefined);
    const hasWaterSupply = _.get(constructionDetailsVM, 'waterSupply.value', undefined);
    const hasSplitPPC = _.get(constructionDetailsVM, 'splitPPC.value', undefined);
    const hasFireDistrictName = _.get(constructionDetailsVM, 'fireDistrictName.value', undefined);
    const [fireDistrictValues, setFireDistrictValues] = useState(fireDistrictInitialValues);

    const fireDistrictDropdownValues = fireDistrictValues.length > 1
        ? fireDistrictValues
        : fireDistrictName
            ? [fireDistrictName]
            : [];

    const isRefreshBtnVisible = () => {
        return addressMatch?.toLowerCase() === 'z' && fireDistrictName !== '';
    };

    const isHydrantValueDisabled = () => {
        const val1 = addressMatch?.toLowerCase() === 'a' && !_.isUndefined(hasSplitPPC) && !_.isUndefined(hasWaterSupply) && hasWaterSupply == '-';
        const val2 = addressMatch?.toLowerCase() === 'z' && !_.isUndefined(hasSplitPPC) && fireDistrictName !== '';

        return !(val1 || val2);
    };

    const [selectedHydrantValue, setSelectedHydrantValue] = useState(hydrant1000FtValue);
    const [isFireDistrictEditable, setIsFireDistrictEditable] = useState((!fireDistrictName || fireDistrictName == '') && fireDistrictValues.length > 1);
    const [isHydrantEditable, setIsHydrantEditable] = useState(!isHydrantValueDisabled());
    const [isRefreshButtonVisible, setIsRefreshButtonVisible] = useState(isRefreshBtnVisible());

    const [selectedFireDistrictValue, setSelectedFireDistrictValue] = useState(fireDistrictDropdownValues.find(item =>
        item.split(';')[0].trim() === fireDistrictName
    ) || (fireDistrictName ?? ''));

    useEffect(() => {
        setIsRefreshButtonVisible(isRefreshBtnVisible());
        setIsHydrantEditable(!isHydrantValueDisabled())
    }, [constructionDetailsVM, fireDistrictName, isRefreshButtonVisible, selectedHydrantValue]);



    const setVehicleAssignmentsToSingleDriver = useCallback((driver) => {
        const eligibleVehicles = vehicles.filter((veh) => isVehicleEligibleForAccidentPrevention(veh));
        vehicleDriversVM.value = [];
        eligibleVehicles.forEach((veh) => {
            const vehicleDriver = viewModelService.create({}, 'pc', 'edge.capabilities.policyjob.lob.personalauto.coverables.dto.VehicleDriverDTO');
            vehicleDriver.vehicleID.value = veh.fixedId;
            vehicleDriver.driverID.value = driver.fixedId;
            vehicleDriver.percentageDriven_Ext.value = 100;
            vehicleDriversVM.pushElement(vehicleDriver.value);
        });
    }, [isVehicleEligibleForAccidentPrevention, vehicleDriversVM, vehicles, viewModelService]);

    useEffect(() => {
        Identify('Endorsement Step Reached', {step: 'Additional Policy Info Screen'}, submissionVM, authHeader)
    }, [])

    useEffect(() => {
        if (ratedDrivers.length === 1 && (isVehiclePrimaryDriverState || isVehiclePrimaryDriverPercentageState)) {
            setVehicleAssignmentsToSingleDriver(ratedDrivers[0]);
        }
        MLDisclosureUtil.setRequoteAfterMvr(submissionVM.jobID.value, false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (isGpa) {
            PolChangeTrackEvent('Endorsement Step Reached', false, submissionVM, authHeader, { step: 'PolChange Additional Policy Info Screen' });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    const getPrimaryDriverList = useCallback(() => {
        const primaryDriverList = [];
        vehicles.forEach((el) => {
            const tmp = vehicleDriversVM.children.filter((vd) => vd.vehicleID.value === el.fixedId);
            if (tmp !== undefined && tmp.length > 0) {
                const r = Math.max(...tmp.map((ar) => ar.percentageDriven_Ext.value));
                primaryDriverList.push(tmp.find((t) => parseInt(t.percentageDriven_Ext.value, 10) === r).driverID.value);
            }
        });
        return primaryDriverList;
    }, [vehicleDriversVM, vehicles]);

    const hasMissingRequiredDriverAssignment = useCallback(() => {
        let hasMissing = false;
        if (vehicleDriversVM.value.some((vd) => vd.driverID === null)) {
            addErrorAlert(ASSIGNMENT_REQ_ERR, 'assignmentRequiredError');
            hasMissing = true;
        } else {
            clearBlockAlerts('assignmentRequiredError')
        }
        return hasMissing;
    }, [ASSIGNMENT_REQ_ERR, addErrorAlert, clearBlockAlerts, vehicleDriversVM?.value]);

    const missingPrimaryVehicleAssignment = useCallback(() => {
        clearBlockAlerts('driverVehicleError');
        if (hasPrimaryVehicleRequiredDriver) {
            ratedDrivers.forEach((driver) => {
                if (driver.driverModifiers_ML.isPrimaryVehicleRequired_ML && !driver.driverModifiers_ML.primaryVehicleFixedId) {
                    addErrorAlert(messages.driverVehicleError, 'driverVehicleError');
                    setHasError(true);
                    window.scrollTo(0, 0);
                }
            });
        }
        return hasError;
    }, [addErrorAlert, clearBlockAlerts, hasError, hasPrimaryVehicleRequiredDriver, ratedDrivers]);

    const primaryDriversError = useCallback(() => {
        let hasPrimaryDriversError = false;
        clearBlockAlerts('vehicleDriverError')
        if (hasMissingRequiredDriverAssignment()) {
            return true;
        }
        const eligibleVehicles = vehicles.filter((veh) => isVehicleEligibleForAccidentPrevention(veh));
        const primaryDriverList = getPrimaryDriverList();
        if (eligibleVehicles.length >= ratedDrivers.length) {
            const residentStudent = [];
            ratedDrivers.forEach((ratedDriver) => {
                ratedDriver.driverModifiers_ML.modifiers.forEach((modifier) => {
                    if (modifier.codeIdentifier_ML === residentStudentCode && modifier.chosenTermValue === 'true') {
                        residentStudent.push(ratedDriver);
                    }
                });
            });
            const resStudentArr = [];
            residentStudent.forEach((res) => {
                resStudentArr.push(res.fixedId);
            });
            vehicleDriversVM.value.forEach((res) => {
                if (res.percentageDriven_Ext === HALF_DRIVER) {
                    addErrorAlert(VEH_DRV_ERR, 'vehicleDriverError');
                } else {
                    clearBlockAlerts('vehicleDriverError')
                }
            });

            ratedDrivers.forEach((el) => {
                if (!resStudentArr.includes(el.fixedId) && !primaryDriverList.includes(el.fixedId)) {
                    addErrorAlert(VEH_DRV_ERR, 'vehicleDriverError');
                }
            });
        } else {
            vehicleDriversVM.value.forEach((res) => {
                if (res.percentageDriven_Ext === HALF_DRIVER) {
                    addErrorAlert(VEH_DRV_ERR, 'vehicleDriverError');
                } else {
                    clearBlockAlerts('vehicleDriverError')
                }
            });
            if (primaryDriverList.length !== new Set(primaryDriverList).size) {
                addErrorAlert(VEH_DRV_ERR, 'vehicleDriverError');
                hasPrimaryDriversError = true;
                window.scrollTo(0,0);
            } else {
                clearBlockAlerts('vehicleDriverError')
            }
        }
        return hasPrimaryDriversError;
    }, [VEH_DRV_ERR, addErrorAlert, clearBlockAlerts, getPrimaryDriverList, hasMissingRequiredDriverAssignment, ratedDrivers, vehicleDriversVM?.value, vehicles]);

    const areVehiclePrimaryDriverAssignmentPercentagesInvalid = useCallback(() => {
        let areAssignmentsInvalid = false;
        const primaryDriverList = [];
        clearBlockAlerts('vehicleDriverError')
        clearBlockAlerts('assignmentRequiredError')
        clearBlockAlerts('totalPctError')

        vehicleDriversVM.value.forEach((vd) => {
            if (!vd.percentageDriven_Ext) {
                vd.percentageDriven_Ext = 0;
            }
        });

        const eligibleVehicles = vehicles.filter((veh) => isVehicleEligibleForAccidentPrevention(veh));
        const ratedDriversNonStudent = getRatedDriversNonStudent(ratedDrivers);
        if (eligibleVehicles.length > 0) {
            if (!validateVehiclesHaveAssignmentsForEveryDriver(eligibleVehicles, ratedDrivers, vehicleDriversVM)) {
                addErrorAlert(ASSIGNMENT_REQ_ERR, 'assignmentRequiredError');
                areAssignmentsInvalid = true;
            }

            if (!validateVehicleAssignmentPercentages(eligibleVehicles, vehicleDriversVM)) {
                addErrorAlert(TOTAL_PCT_ERROR, 'totalPctError');
                areAssignmentsInvalid = true;
            }

            // capture primary drivers for all eligible vehicles
            let multiplePrimaryDrivers = false;
            eligibleVehicles.forEach((vehicle) => {
                const vehicleAssignments = vehicleDriversVM.value.filter((vd) => vd.vehicleID === vehicle.fixedId);
                if (vehicleAssignments.length > 0) {
                    const max = Number(Math.max(...vehicleAssignments.map((ar) => ar.percentageDriven_Ext)));
                    if (vehicleAssignments.filter((va) => va.percentageDriven_Ext === max).length > 1) {
                        multiplePrimaryDrivers = true;
                    }
                    primaryDriverList.push(vehicleAssignments.find((t) => parseInt(t.percentageDriven_Ext, 10) === max).driverID);
                }
            });

            if (multiplePrimaryDrivers) {
                addErrorAlert(VEH_DRV_ERR, 'vehicleDriverError');
                areAssignmentsInvalid = true;
            } else if (ratedDriversNonStudent.length >= eligibleVehicles.length) {
                // check that driver isn't primary on more than one vehicle
                if (primaryDriverList.length !== new Set(primaryDriverList).size) {
                    addErrorAlert(VEH_DRV_ERR, 'vehicleDriverError');
                    areAssignmentsInvalid = true;
                }
            } else {
                // check that each rated driver is primary on at least one vehicle
                ratedDriversNonStudent.forEach((driver) => {
                    if (!primaryDriverList.includes(driver.fixedId)) {
                        addErrorAlert(VEH_DRV_ERR, 'vehicleDriverError');
                        areAssignmentsInvalid = true;
                    }
                });
            }
        } else if (vehicleDriversVM.length > 0) {
            vehicleDriversVM.value = [];
        }
        return areAssignmentsInvalid;
    }, [ASSIGNMENT_REQ_ERR, TOTAL_PCT_ERROR, VEH_DRV_ERR, addErrorAlert, clearBlockAlerts, getRatedDriversNonStudent, isVehicleEligibleForAccidentPrevention, ratedDrivers, validateVehicleAssignmentPercentages, validateVehiclesHaveAssignmentsForEveryDriver, vehicleDriversVM, vehicles]);

    const defaultAssignmentsToDriver = (() => (vehicle, driver) => {
        const eligibleVehicles = vehicle.filter((veh) => isVehicleEligibleForAccidentPrevention(veh));
        eligibleVehicles.forEach((veh) => {
            const vehDriver = vehicleDriversVM.value.find((vd) => vd.vehicleID === veh.fixedId);
            if (vehDriver) {
                vehDriver.driverID = driver.fixedId;
            } else {
                const vehicleDriver = viewModelService.create({}, 'pc', 'edge.capabilities.policychange.lob.personalauto.draft.dto.VehicleDriverDTO');
                vehicleDriver.vehicleID.value = veh.fixedId;
                vehicleDriver.driverID.value = driver.fixedId;
                vehicleDriver.percentageDriven_Ext.value = 100;
                vehicleDriversVM.pushElement(vehicleDriver.value);
            }
        });
    }, []);

    const showVehicleListSection = useMemo(() => {
        let primaryDriverRequired = false;
        if ((isVehiclePrimaryDriverState || isVehiclePrimaryDriverPercentageState)
            && drivers.length > 1) {
            drivers.forEach((driver) => {
                _.get(driver, 'driverModifiers_ML.modifiers', []).forEach((modifier) => {
                    if (accidentPreventionCode.indexOf(modifier.codeIdentifier_ML) > -1) {
                        if (modifier.chosenTermValue === 'true') primaryDriverRequired = true;
                    }
                });
            });
        }
        if(state === 'MN') {
            if (paModifiers && paModifiers.lineModifiers.value) {
                paModifiers.lineModifiers.value.forEach((modifier) => {
                    if (WLBForSeniorsCode.indexOf(modifier.codeIdentifier_ML) > -1) {
                        if (modifier.chosenTermValue === 'true') primaryDriverRequired = true;
                    }	
                }
                );
            }
        }    
        if (primaryDriverRequired && drivers.length === 1) {
            defaultAssignmentsToDriver(vehicles, drivers[0].value);
            primaryDriverRequired = false;
        }
        return primaryDriverRequired;
    }, [drivers, isVehiclePrimaryDriverPercentageState, isVehiclePrimaryDriverState, defaultAssignmentsToDriver, vehicles]);
    
    const validateQuestionSets = useCallback(() => {
        if (!_.isEmpty(questionSetsAspects) && (!questionSetsAspects.valid
            || !questionSetsAspects.subtreeValid)) {
            return false;
        }
        return true;
    }, [questionSetsAspects]);

    const performPageValidation = useCallback(() => {
        return validateQuestionSets() && submissionVM.aspects.valid && submissionVM.aspects.subtreeValid && !hasError;
    }, [hasError, submissionVM.aspects.subtreeValid, submissionVM.aspects.valid, validateQuestionSets]);

    useEffect(() => {
        registerComponentValidation(performPageValidation);
    }, [performPageValidation, registerComponentValidation]);

    const syncHouseholdAdditionalQuestionSets = useCallback((aQuestionSetAnswersValue) => {
        if (questionSets) {
            const syncPromise = EndorsementService.syncQuestionSetML(jobNumber, [aQuestionSetAnswersValue], authHeader);
            showProgressDialog(platformMessages.syncingQuestions, syncPromise, true);
            syncPromise.then((updatedQuestions) => {
                const transformedQuestions = {};
                updatedQuestions.forEach((q) => { transformedQuestions[q.code] = q; });
                _.set(submissionVM, 'lobData.personalAuto.questionSets_ML.preQualification.value', transformedQuestions.PAPersonalAutoPreQual);
                _.set(submissionVM, 'lobData.personalAuto.questionSets_ML.houseAdditionalInformation.value', transformedQuestions.PAHouseAdditionalInformation_ML);
                _.set(submissionVM, 'lobData.personalAuto.questionSets_ML.priorInsurance.value', transformedQuestions.PAPriorInsurance_ML);
                updateWizardData(wizardData);
            });
        }
    }, [questionSets, EndorsementService, jobNumber, authHeader, showProgressDialog, submissionVM, updateWizardData, wizardData]);

    const checkOwnsResidenceModifier = (mod, copiedView) => {
        if (mod.patternCode.value === 'z70hmvhmucbde2eo899j9kmgjdb') {
            if (mod.chosenTermValue.value) {
                if (!copiedView.lobData.personalAuto.modifiers_ML.yearsAtCurrentResidence) {
                    copiedView.lobData.personalAuto.modifiers_ML.yearsAtCurrentResidence = 0;
                }
            }
        }
    };

    const syncModifiers = (submissionData, mlModifier) => {
        submissionData.forEach((mod) => {
            const oldMod = mlModifier.value.find((value) => {
                return value.patternCode === mod.patternCode;
            });
            _.set(mod, 'chosenTermValue', oldMod ? oldMod.chosenTermValue : null);
            if (mod.valueType === 'date') {
                mod.dateValue_ML = oldMod ? oldMod.dateValue_ML : null;
            } else if (mod.valueType === 'boolean') {
                mod.chosenTermValue = mod.chosenTermValue ? mod.chosenTermValue : 'false';
            }
            _.set(mod, 'savedFromPortal', true);
            _.set(mod, 'editMode_ML', true);
        });
        _.set(mlModifier, 'value', submissionData);
    };

    const syncModifierDependentQuestions = (submissionData, mlModifier) => {
        if (mlModifier.yearsAtCurrentResidence) {
            mlModifier.yearsAtCurrentResidence.value = submissionData.yearsAtCurrentResidence;
        }
    };

    const updateModifier = (mod) => {
        _.set(mod, 'updated.value', true);
        const validMods = [];
        const copiedModel = viewModelService.clone(submissionVM);

        for (let i = 0; i < modifiers.lineModifiers.length; i += 1) {
            const modifier = modifiers.lineModifiers.children[i];
            checkOwnsResidenceModifier(modifier, copiedModel);
            if (modifier.aspects.subtreeValid) {
                validMods.push(modifier.value);
            }
        }

        _.set(copiedModel, 'lobData.personalAuto.modifiers_ML.lineModifiers', validMods);

        let submissionLoadPromise;
        if (isPersonalAuto) {
            submissionLoadPromise = EndorsementService.updateModifiersML([copiedModel.value], authHeader);
        } else {
            submissionLoadPromise = EndorsementService.saveEndorsement([copiedModel.value], authHeader);
        }

        showProgressDialog(platformMessages.syncing, submissionLoadPromise, true);
        submissionLoadPromise.then((submissionData) => {
            syncModifiers(submissionData.lobData.personalAuto.modifiers_ML.lineModifiers, modifiers.lineModifiers);
            syncModifierDependentQuestions(submissionData.lobData.personalAuto.modifiers_ML, modifiers);
            updateWizardData(wizardData);
        });
    };

    const showAnimalExclusionWarningMessage = useCallback((shouldShow) => {
        const messageName = 'HOPPolicyChangeLocationAnimalExclusionWarning';
        clearBlockAlerts(messageName);
        if (shouldShow) {
            const message = messages.animalExclusionWarningMessage;
            addWarningAlert(message, messageName);
            window.scrollTo(0, 0);
        }
    }, [addWarningAlert, clearBlockAlerts]);

    const removeQuestionsFromPreQual = useCallback(() => {
        if (!isGpa || !isModernProduct || !isHomeowners) {
            return;
        }
        const answersPath = 'lobData.homeowners.dwellingAdditionalInfo.value[0].answers';
        const answers = _.get(submissionVM, answersPath);
        if (!answers) {
            return;
        }
        PREQUAL_QUESTIONS_TO_REMOVE.forEach((questionCode) => {
            _.unset(answers, questionCode);
        });
    }, [isGpa, isModernProduct, isHomeowners]);

    useEffect(() => {
        showAnimalExclusionWarningMessage(_.get(submissionVM.lobData.homeowners, 'shouldDisplayAnimalExclusionWarning_ML.value'));
        removeQuestionsFromPreQual()
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const updateDogBreedsAndOtherExiotAnimalsValues = useCallback((questions = {}) => {
        let dwellingQs = questions

        if (_.isEmpty(dwellingQs)) {
            dwellingQs = _.get(submissionVM, 'lobData.homeowners.dwellingAdditionalInfo.value[0]', {})
        }

        const dwellingAs = dwellingQs.answers;
        const updatedValues = {};

        Object.keys(dogBreedsAndOtherExiotAnimals).forEach((item) => {
            const updatedValue = dwellingAs[item] ?? null

            updatedValues[item] = updatedValue
        });

        return updatedValues
    }, [dogBreedsAndOtherExiotAnimals, submissionVM])


    const syncPreQualQuestionSets = useCallback((questionSetAnswers) => {
        setQualWarningsAck(false);
        const tenantAnswer = questionSetAnswers.answers?.HOPPreQualOccupant;
        const isTenantSelected = tenantAnswer === "HOPPreQualOccupantTenant";
        const offeringCode = _.get(submissionVM, 'lobData.homeowners.offerings.value[0].branchCode');
        const isValuePlusCondo = offeringCode === "HOPGoodCondo_ML";
        const isInvalidLandlordCondo = isCondo && isTenantSelected && !isValuePlusCondo;
        // US1104862 - PE validation: Block Condo → Tenant for non–Value Plus. Executed on change since policy type/offering updates happen before validateData.
        if (isInvalidLandlordCondo) {
            const title = translator(messages.invalidLandlordOfferingErrorTitle);
            const message = translator(messages.invalidLandlordOffering);
            _.set(submissionVM, `${preQualQuestionSetPath}.answers.HOPPreQualOccupant`, "HOPPreQualOccupantMyself");
            showErrorModal(title, message);
            return;
        }
        const syncPromise = EndorsementService.syncQuestionSetML(jobNumber, [questionSetAnswers], authHeader);
        showProgressDialog(platformMessages.syncingQuestions, syncPromise, true);
        syncPromise.then(
            (updatedQuestionSets) => {
                const answers = _.find(updatedQuestionSets, (qs) => qs.code === questionSetCode);
                
                _.set(submissionVM, preQualQuestionSetPath, answers);
                
                if (isHomeowners) {
                    const shouldShowAnimalExclusionWarningQs = updatedQuestionSets.find((q) => q.code === 'ShouldDisplayAnimalExclusionWarning_ML');
                    const shouldShowWarning = _.get(shouldShowAnimalExclusionWarningQs, 'answers.ShouldDisplayAnimalExclusionWarning_ML', 'false') === 'true'
                    const dwellingQs = updatedQuestionSets.find((q) => q.code === 'HOPDwellingAddlInfo_ML');
                    const updatedValues =  updateDogBreedsAndOtherExiotAnimalsValues(dwellingQs);

                    if(!_.isEqual(updatedValues , dogBreedsAndOtherExiotAnimals))
                    {
                        setDogBreedsAndOtherExiotAnimals(updatedValues)
                        showAnimalExclusionWarningMessage(shouldShowWarning);

                    }
                }

                updateWizardData(wizardData);
            }
        );
    }, [EndorsementService, jobNumber, authHeader, showProgressDialog, 
        submissionVM, preQualQuestionSetPath, isHomeowners, updateWizardData, wizardData, 
        questionSetCode, updateDogBreedsAndOtherExiotAnimalsValues, dogBreedsAndOtherExiotAnimals, 
        showAnimalExclusionWarningMessage]);

    const syncDwellingInfoQuestionSets = (questionSetAnswers, questionSetPath, qsQuestionType) => {
        if (qsQuestionType === "String") {
            _.set(submissionVM, questionSetPath, questionSetAnswers);
            refreshData();
        } else {
            const syncPromise = EndorsementService.syncQuestionSetML(jobNumber, [questionSetAnswers], authHeader);

            showProgressDialog(platformMessages.syncingQuestions, syncPromise, true);
            syncPromise.then((updatedQuestionSets) => {
                const dwellingQs = updatedQuestionSets.find((q) => q.code === 'HOPDwellingAddlInfo_ML');
    
                _.set(submissionVM, questionSetPath, dwellingQs);

                if (isHomeowners) {
                    const animalWarningPromise = EndorsementService.HOShouldDisplayAnimalExclusionWarning(jobNumber, authHeader);
                    const updatedValues =  updateDogBreedsAndOtherExiotAnimalsValues(dwellingQs);

                    animalWarningPromise.then((result) => {

                        if (!_.isEqual(updatedValues , dogBreedsAndOtherExiotAnimals)) {
                            setDogBreedsAndOtherExiotAnimals(updatedValues)
                            showAnimalExclusionWarningMessage(result);

                        }
                    })

                }
            });
        }
    };

    const isAccidentPreventionCourse = useCallback(() => {
        let nonAcciPrevModifier = false;
        if (submissionVM.value.isVehiclePrimaryDriverPercentageState_Ext && showVehicleListSection) {
            drivers.forEach((driver) => {
                if (driver.driverModifiers_ML.modifiers) {
                    driver.driverModifiers_ML.modifiers.forEach((modifier) => {
                        if (accidentPreventionCode.indexOf(modifier.codeIdentifier_ML) > -1) {
                            if (modifier.chosenTermValue === 'false') nonAcciPrevModifier = true;
                        }
                    });
                }
            });
        }
        return nonAcciPrevModifier;
    }, [drivers, showVehicleListSection, submissionVM]);

    
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const checkNoAnimalSpecifiedError = useCallback(() => {
        if(isHomeowners) {
            return dwellingInfoQuestionSetData &&
            dwellingInfoQuestionSetData.answers[DWELLING_QUESTION_SET.ANSWERS.HAVE_ANIMALS] === 'true' &&
            dwellingInfoQuestionSetData.answers[DWELLING_QUESTION_SET.ANSWERS.DOG] === 'false' &&
            dwellingInfoQuestionSetData.answers[DWELLING_QUESTION_SET.ANSWERS.FARM_ANIMALS] === 'false' &&
            dwellingInfoQuestionSetData.answers[DWELLING_QUESTION_SET.ANSWERS.EXOTIC_ANIMALS] === 'false' &&
            dwellingInfoQuestionSetData.answers[DWELLING_QUESTION_SET.ANSWERS.OTHER] === 'false';
        }
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const jumpToSelectedStepByStepID = (newStepID) => {
        MLEndorsementFlowUtil.addAndNavigateToSelectedStep(newStepID, steps, currentStepIndex, changeNextSteps, goNext, submissionVM.baseData.productCode.value) 
    };


    const executeNextSteps = () => {
        if (submissionVM.aspects.valid && submissionVM.aspects.subtreeValid && isComponentValid) {
            updateWizardData(wizardData);
            if (isTilePage) {
                MLNavigationStepsTrackingService.completeCurrentStep(null, authHeader);
                jumpToSelectedStepByStepID('endorsementAdditionalChanges');
            } else {
                MLNavigationStepsTrackingService.completeAllDynamicSteps(authHeader);
                submissionVM.value.portalCurrentStep_ML = currentStep.mlStepName;
                goNext();
            }
        } else {
            setShowErrors(true);
            setErrorTimestamp(errorTimestamp+1);
        }
    }

    const onNext = useCallback(() => {
        if (isPersonalAuto) {
            if (missingPrimaryVehicleAssignment()) {
                return;
            }

            if (showVehicleListSection) {
                if (isVehiclePrimaryDriverState) {
                    if (primaryDriversError()) {
                        return;
                    }
                } else if (isVehiclePrimaryDriverPercentageState) {
                    if (areVehiclePrimaryDriverAssignmentPercentagesInvalid()) {
                        window.scrollTo(0, 0);
                        return;
                    }
                }
            }
            
            if (!nonAccidentPreventionDisplayed && isAccidentPreventionCourse()) {
                displayNonAPModifierLAMessage();
                setNonAccidentPreventionDisplayed(true);
                return;
            }
        }
        if (isHomeowners) {
              clearBlockAlerts('noAnimalSpecifiedError');
            if (isModernProduct) {
                        const answersAtSubmit =
                            _.get(submissionVM, 'lobData.homeowners.preQualQuestionSets.value[0].answers', {}) || {};
            
                        const { active: warningsActive } = showQualificationWarnings({
                            answers: answersAtSubmit,
                            renderNow: true,
                        });
            
                        if (warningsActive && !qualWarningsAck) {
                            setQualWarningsAck(true);
                            return ;
                        }
                   }

            if (checkNoAnimalSpecifiedError()) {
                addErrorAlert(messages.showAnimalSpecificMessage, 'noAnimalSpecifiedError');
                return;
            }
            const lbl = MLEndorsementUtil.stepLabel(currentStep);
            MLEndorsementUtil.setEndorsementDescription(lbl, submissionVM, translator);

            const promise = EndorsementService.saveAndQuote(submissionVM.value, authHeader);
            showProgressDialog(platformMessages.savingPolicyChange, promise);
            promise.then((updatedPolicyChange) => {
                const policyChange = new PolicyChange(updatedPolicyChange);
                const updatedEndorsementVM = viewModelService.create(policyChange, 'pc', 'edge.capabilities.policychange.dto.PolicyChangeDataDTO');
                updateWizardSubmissionData(updatedEndorsementVM);
                executeNextSteps();
            })
        } else {
            executeNextSteps();
        }

        if (isGpa) {
            PolChangeTrackEvent('Endorsement Step Submitted', false, submissionVM, authHeader, {
                step: 'PolChange Additional Policy Info Screen',
                action: 'Additional Policy Info Submitted'
            })
        }
        
        return submissionVM;
    }, [isPersonalAuto, isHomeowners, isGpa, submissionVM, missingPrimaryVehicleAssignment, showVehicleListSection, nonAccidentPreventionDisplayed, isAccidentPreventionCourse, isVehiclePrimaryDriverState, isVehiclePrimaryDriverPercentageState, primaryDriversError, areVehiclePrimaryDriverAssignmentPercentagesInvalid, displayNonAPModifierLAMessage, clearBlockAlerts, checkNoAnimalSpecifiedError, currentStep, translator, EndorsementService, authHeader, showProgressDialog, addErrorAlert, viewModelService, updateWizardSubmissionData, executeNextSteps]);

    const showReminderAlert = () => {
        const part1 = translator(messages.Reminder, {
            strong: (chunks) => <strong>{chunks}</strong>
        });
        const part2 = isPersonalUmbrella ? translator(messages.pleaseUpdateDueToPolChange) : translator(messages.PleaseUpdate);
        addWarningAlert({...messages.existingChangeAlert, args: {
            msg1: part1,
            msg2: part2
        }}, null, '');
    };

    const getDynamicStepName = () => {
        return isTilePage ? translator(messages.updatedAddtlPolicyInfo) : translator(messages.verifyAdditionalDetails);
    };

    const checkReadOnlyAnswer = (key) => {
        return false;
    };

    const checkMatureDriverDiscount = () => {
        for (const driver of drivers ?? []) {
            const modifiers = _.get(driver, "driverModifiers_ML.modifiers");
            const isMatureDriverDiscountApplied = modifiers?.find(modifier => modifier?.codeIdentifier_ML === "PAMatureDriver_Ext")?.chosenTermValue === "true";
            if (isMatureDriverDiscountApplied) {
                const primaryVehicleFixedId = _.get(driver, "driverModifiers_ML.primaryVehicleFixedId");
                const primaryVehicleUse = vehicles?.find(vehicle => vehicle?.fixedId === primaryVehicleFixedId)?.primaryUse;
                if (primaryVehicleUse !== "pleasure") {
                    setMatureDriverDiscountWarning(true);
                    return;
                }
            }
        }
    };

    // Initial Load
    useEffect(() => {
        MLNavigationStepsTrackingService.addToDynamicSteps(getDynamicStepName(), false, currentStep.mlStepName, authHeader);
        if (isGpa && !isTilePage) {
            showReminderAlert();
        }

        if (isHomeowners) {
           const updatedValues = updateDogBreedsAndOtherExiotAnimalsValues();

            setDogBreedsAndOtherExiotAnimals(updatedValues);
            showAnimalExclusionWarningMessage(_.get(submissionVM, 'lobData.homeowners.shouldDisplayAnimalExclusionWarning_ML.value', false));
        }

        if (isPersonalAuto) {
            checkMatureDriverDiscount();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const computeQualificationWarningMessages = useCallback(
        (answers) => {
            const msgs = [];
            const occCode = getFirstExisting(answers, dwellingOccupancyKey);

            if (occCode === dwellingOccupancyCode.HomeCondoVacant && (isHomeOwnersPartialTypeHome || isHomeOwnersPartialTypeCondo)) {
                msgs.push(translator(messages.vacantDwellingUWWarning));
            }

            if (occCode === dwellingOccupancyCode.LandlordVacant && isLLHOrLLC) {
                if (offeringCode === offeringLLHLLC.LandlordCondo) {
                    msgs.push(translator(messages.vacantDwellingUWWarningLandlordCondo));
                } else if (offeringCode === offeringLLHLLC.LandlordHome) {
                    msgs.push(translator(messages.vacantDwellingUWWarningLandlordHome));
                }
            }

            const dayCare = _.get(answers, isDayCareSelected);
            const animalVal = _.get(answers, animalBittenOrAttackedKey);
            if (isTruthyYes(animalVal)) {
                msgs.push(translator(messages.animalLiabilityExclusion));
            }
            if (isTruthyYes(dayCare) && !isHomeOwnersPartialTypeRental) {
                msgs.push(translator(messages.dayCareNotification))
            }

            return msgs;
        },
        []
    );

    const showQualificationWarnings = useCallback(
        ({
            answers,
            renderNow,
        }) => {
            const messageList = computeQualificationWarningMessages(answers);

            if (messageList.length === 0) {
                if (qualWarningsActiveRef.current) {
                    clearBlockAlerts(warningKey);
                }
                qualWarningsActiveRef.current = false;
                setQualWarningsAck(false);
                return { active: false };
            }

            if (!qualWarningsActiveRef.current) {
                setQualWarningsAck(false);
            }
            qualWarningsActiveRef.current = true;

            if (renderNow) {
                clearBlockAlerts(warningKey);
                const content = (
                    <div>
                        {messageList.map((m, idx) => (
                            <div key={idx}>{m}</div>
                        ))}
                    </div>
                );
                addWarningAlert(content, warningKey);
            }

            return { active: true };
        },
        [computeQualificationWarningMessages]
    );

    const overrides = {
        additionalPolicyInfoContainer: {
            className: isGpa ? 'page-content-gpa' : undefined
        },
        ampPageHeaderContainer: {
            visible: !isGpa
        },
        gpaPAPageHeaderContainer: {
            visible: isGpa && isPersonalAuto
        },
        gpaHOPageHeaderContainer: {
            visible: isGpa && isHomeowners
        },
        gpaPUPPageHeaderContainer: {
            visible: isGpa && isPersonalUmbrella
        },
        matureDriverDiscountWarningDiv: {
            visible: matureDriverDiscountWarning
        },
        houseadditionalquestionset: {
            labelPosition: 'top',
            model: submissionVM,
            onValidate: onValidate,
            onValueChange: syncHouseholdAdditionalQuestionSets
        },
        modifierComponent: {
            modifier: modifiers.lineModifiers,
            updateModifier: updateModifier,
            onValidate: onValidate,
            visible: !_.isUndefined(modifiers),
            showPopover: false,
            isPolicyChange: true,
            showValidationErrors: showErrors
        },
        driversListComponent: {
            paModel: lineModel,
            refreshData,
            isPrimaryVehicleReqState: isPrimaryVehicleReqState,
            state: state,
            isPolicyChange: true
        },
        vehiclesListComponent: {
            visible: showVehicleListSection,
            isVehiclePrimaryDriverState,
            isVehiclePrimaryDriverPercentageState,
            drivers: ratedDrivers,
            vehicles,
            vehicleDrivers: vehicleDriversVM,
            vehicleDriverErrors,
            setVehicleDriverErrors,
            isPolicyChange: true,
            isGPA: isGpa
        },
        dwellingQuestionSet: {
            path: 'lobData.homeowners.dwellingAdditionalInfo.value[0]',
            onValueChange: syncDwellingInfoQuestionSets,
            showHeaderML: false,
            onValidate,
            showErrors,
            checkReadOnlyAnswer
        },
        hoPreQualQuestionSet: {
            path: preQualQuestionSetPath,
            labelPosition: 'top',
            showHeaderML: false,
            onValueChange: syncPreQualQuestionSets,
            onValidate,
            showErrors,
            checkReadOnlyAnswer
        },
        pupPreQualQuestionSet: {
            path: preQualQuestionSetPath,
            labelPosition: 'top',
            showHeaderML: false,
            onValueChange: syncPreQualQuestionSets,
            onValidate,
            showErrors
        },
        nextDescription: {
            content: (
                <FormattedMessage
                    {...messages.nextLabel}
                    values={{
                        additionalChangesAreNeeded: (
                            <strong>{translator(messages.additionalChangesAreNeeded)}</strong>
                        )
                    }}
                />
            )
        },
        stickyContinueSection: {
            visible: isGpa,
            defaultContinueSectionId: 'footer',
            nextDescription: (
                <FormattedMessage
                    {...messages.nextLabel}
                    values={{
                        additionalChangesAreNeeded: (
                            <strong>{translator(messages.additionalChangesAreNeeded)}</strong>
                        )
                    }}
                />
            ),
            onNext
        },
        HOAdditionalPolicyInfoContainer: {
            visible: HOAdditionalPolicyInfoContainer
        },
        PAAdditionalPolicyInfoContainer: {
            visible: PAAdditionalPolicyInfoContainer
        },
        PUPAdditionalPolicyInfoContainer: {
            visible: PUPAdditionalPolicyInfoContainer
        },
        ppcContainer: {
            visible: isHomeOwnersPartialTypeRental && isModernProduct && (!_.isUndefined(hasSplitPPC) || addressMatch?.toLowerCase() === 'z')
        },

        hydrantWithin1000ft: {
            disabled: !isHydrantEditable,
            value: selectedHydrantValue,
            visible: !_.isUndefined(hasSplitPPC),
            required: isHomeOwnersPartialTypeRental && isModernProduct,
            onValueChange: (value) => {
                _.set(
                    constructionDetailsVM,
                    'hydrantWithIn1000Feet.value',
                    value
                );
                setSelectedHydrantValue(value)
                setIsHydrantEditable(!isHydrantValueDisabled())
            }
        },

        fireDistrict: {
            disabled: !isFireDistrictEditable,
            value: fireDistrictDropdownValues.find(item => item.split(';')[0].trim() === fireDistrictName) || fireDistrictName,
            visible: addressMatch?.toLowerCase() === 'z',
            required: isHomeOwnersPartialTypeRental && isModernProduct,
            availableValues: fireDistrictDropdownValues.map(item => ({
                code: item,
                name: item,
            })),
            onValueChange: (selectedValue) => {
                setIsFireDistrictEditable(false);
                const selectedFireDistrict =
                    typeof selectedValue === 'string'
                        ? selectedValue
                        : selectedValue?.code || selectedValue?.value || '';

                _.set(
                    constructionDetailsVM,
                    'fireDistrictName.value',
                    selectedFireDistrict
                );
                _.set(
                    constructionDetailsVM,
                    'isFireDistrictNameEditable.value',
                    false
                );
            }
        },
        refreshButton: {
            visible: isRefreshButtonVisible,
            onClick: resetValues,
        },
    };

    const resolvers = {
        resolveComponentMap: {
            driverslistcomponent: DriversListComponent,
            vehicleslistcomponent: VehiclesListComponent,
            questionset: QuestionSetComponent,
            modifiercomponent: MLModifierComponent,
        },
        resolveCallbackMap: {
            onNext,
            resetValues
        },
        resolveClassNameMap: styles
    };

    return (
        <WizardPage
            showPrevious={false}
            showCancel={false}
            showNext={false}
            policyChangePageHeaderML={isGpa ? messages.makeChanges : messages.additionalPolicyInfo}
        >
            <ViewModelForm
                uiProps={metadata.pageContent}
                overrideProps={overrides}
                model={submissionVM}
                showErrors={showErrors}
                componentMap={resolvers.resolveComponentMap}
                onModelChange={updateWizardData}
                callbackMap={resolvers.resolveCallbackMap}
                classNameMap={resolvers.resolveClassNameMap}
                onValidationChange={onValidate}
            />
            <ScrollToError counter={errorTimestamp} />
        </WizardPage>
    );
};

AdditionalPolicyInfoPolChange.propTypes = wizardProps;
export default AdditionalPolicyInfoPolChange;
